export interface ContactRecipientProps {
  id: string;
  name: string;
  email: string;
  isActive: boolean;
  displayOrder: number;
  createdAt: Date;
  updatedAt: Date;
}

export class ContactRecipient {
  private readonly _id: string;
  private _name: string;
  private _email: string;
  private _isActive: boolean;
  private _displayOrder: number;
  private readonly _createdAt: Date;
  private _updatedAt: Date;

  private constructor(props: ContactRecipientProps) {
    this._id = props.id;
    this._name = props.name;
    this._email = props.email;
    this._isActive = props.isActive;
    this._displayOrder = props.displayOrder;
    this._createdAt = props.createdAt;
    this._updatedAt = props.updatedAt;
  }

  public static create(props: {
    id: string;
    name: string;
    email: string;
    isActive?: boolean;
    displayOrder?: number;
    createdAt?: Date | string;
    updatedAt?: Date | string;
  }): ContactRecipient {
    return new ContactRecipient({
      id: props.id,
      name: props.name,
      email: props.email,
      isActive: props.isActive ?? true,
      displayOrder: props.displayOrder ?? 0,
      createdAt: props.createdAt ? new Date(props.createdAt) : new Date(),
      updatedAt: props.updatedAt ? new Date(props.updatedAt) : new Date(),
    });
  }

  public get id(): string {
    return this._id;
  }

  public get name(): string {
    return this._name;
  }

  public get email(): string {
    return this._email;
  }

  public get isActive(): boolean {
    return this._isActive;
  }

  public get displayOrder(): number {
    return this._displayOrder;
  }

  public get createdAt(): Date {
    return this._createdAt;
  }

  public get updatedAt(): Date {
    return this._updatedAt;
  }
}
